// Sends a GA4 event through the gtag loaded by gatsby-plugin-google-gtag.
// No-op during SSR or when gtag is blocked.
export const trackEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params)
  }
}
